"use client";

import { useState } from "react";

const days = [
  { h: "34%", m: 22 },
  { h: "43%", m: 27 },
  { h: "39%", m: 26 },
  { h: "52%", m: 33 },
  { h: "47%", m: 31 },
  { h: "64%", m: 41 },
  { h: "59%", m: 38 },
  { h: "74%", m: 46 },
  { h: "68%", m: 43 },
  { h: "85%", m: 52 },
  { h: "79%", m: 49 },
  { h: "94%", m: 58 },
];

const metricCopy: Record<string, { label: string; value: string; unit: string; delta: string; negative?: boolean; title: string; target: string }> = {
  conversions: { label: "Conversions", value: "22.4", unit: "/d", delta: "+18.6%", title: "Conversions by day", target: "Target 20.0" },
  rate: { label: "Conv. rate", value: "4.72", unit: "%", delta: "+0.8%", title: "Conversion rate by day", target: "Target 4.5%" },
  share: { label: "Impression share", value: "31", unit: "%", delta: "−4.2%", negative: true, title: "Impression share by day", target: "Target 38%" },
  cpa: { label: "CPA", value: "$158", unit: "", delta: "−11.2%", title: "CPA by day", target: "Target $170" },
};

export function KpiMonitor() {
  const [selected, setSelected] = useState("conversions");
  const [drilldown, setDrilldown] = useState(false);
  const metric = metricCopy[selected];

  return (
    <div className="mini-app app-kpi">
      <div className="mini-app-head">
        <div>
          <span className="mini-label">KPI Trend Monitor</span>
          <strong>Account health</strong>
        </div>
        <span className="mini-period">Last 30 days ▾</span>
      </div>

      <div className="mini-metrics">
        {Object.entries(metricCopy).map(([key, m]) => (
          <button
            key={key}
            type="button"
            className={`mini-metric${selected === key ? " is-selected" : ""}${m.negative ? " negative" : ""}`}
            onClick={() => {
              setSelected(key);
              setDrilldown(false);
            }}
            aria-pressed={selected === key}
          >
            <span>{m.label}</span>
            <strong>
              {m.value}
              {m.unit && <span>{m.unit}</span>}
            </strong>
            <em>{m.delta}</em>
          </button>
        ))}
      </div>

      <div className="mini-chart">
        <div className="mini-chart-head">
          <span>{metric.title}</span>
          <small>{metric.target}</small>
        </div>
        <div className="trend-bars" aria-hidden="true">
          {days.map((d, index) => (
            <i key={index} style={{ "--h": d.h } as React.CSSProperties} />
          ))}
        </div>
        <div className="chart-axis">
          <span>Jun 04</span>
          <span>Jun 18</span>
          <span>Jul 02</span>
        </div>
      </div>

      <button type="button" className="mini-insight" onClick={() => setDrilldown((open) => !open)} aria-expanded={drilldown}>
        <span className="insight-status" aria-hidden="true">●</span>
        <span>
          <b>Root cause identified</b>
          <small>Landing page experience is slowing mobile conversion</small>
        </span>
        <strong>View 5 actions ↗</strong>
      </button>
      {drilldown && (
        <div className="mini-drilldown">
          <b>Why it moved</b>
          <span>Mobile CVR is 66% below desktop on two high-spend campaigns.</span>
        </div>
      )}
    </div>
  );
}